import React from 'react';
import data from '@emoji-mart/data/sets/15/apple.json';
import Picker from '@emoji-mart/react';

const i18n = require(`@emoji-mart/data/i18n/${ENV.CURRENT_AGENT_LANG || 'es'}.json`);

const EmojisContainer = ({ insertEmoji }) => (
  <div id="emojis-holder" className="emojis-container">
    <Picker
      data={data}
      onEmojiSelect={(emoji) => insertEmoji(emoji)}
      i18n={i18n}
      theme="light"
    />
  </div>
);

export default EmojisContainer;
